/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateEmailConfigDto
 */
export interface CreateUpdateEmailConfigDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEmailConfigDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEmailConfigDto
     */
    companyId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateEmailConfigDto
     */
    emails: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateEmailConfigDto
     */
    teamIds: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateEmailConfigDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the CreateUpdateEmailConfigDto interface.
 */
export function instanceOfCreateUpdateEmailConfigDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "companyId" in value;
    isInstance = isInstance && "emails" in value;
    isInstance = isInstance && "teamIds" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function CreateUpdateEmailConfigDtoFromJSON(json: any): CreateUpdateEmailConfigDto {
    return CreateUpdateEmailConfigDtoFromJSONTyped(json, false);
}

export function CreateUpdateEmailConfigDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateEmailConfigDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'companyId': json['companyId'],
        'emails': json['emails'],
        'teamIds': json['teamIds'],
        'active': json['active'],
    };
}

export function CreateUpdateEmailConfigDtoToJSON(value?: CreateUpdateEmailConfigDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'companyId': value.companyId,
        'emails': value.emails,
        'teamIds': value.teamIds,
        'active': value.active,
    };
}

